/* V18 · accueil : pastilles-filtres de « Nos objets », pause de la bande de garanties, bouton « Revenir en haut ». */
(function () {
  if (window.mp18Ready) return;
  window.mp18Ready = true;
  var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function shop() {
    document.querySelectorAll('[data-mp18-shop]').forEach(function (sec) {
      var pills = sec.querySelectorAll('[data-mp18-filter]');
      var track = sec.querySelector('[data-mp18-track]');
      var live = sec.querySelector('[data-mp18-live]');
      if (!track || !pills.length) return;
      var items = track.querySelectorAll('.mp18-shop__it');
      pills.forEach(function (b) {
        b.addEventListener('click', function () {
          var h = b.getAttribute('data-mp18-filter'), n = 0;
          pills.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          items.forEach(function (li) {
            var ok = h === 'all' || (li.getAttribute('data-cols') || '').indexOf(',' + h + ',') > -1;
            li.hidden = !ok;
            if (ok) n++;
          });
          track.scrollLeft = 0;
          if (live) live.textContent = n + (n > 1 ? ' objets affichés' : ' objet affiché');
        });
      });
    });
  }

  function band() {
    document.querySelectorAll('.mp18-band__vp').forEach(function (vp) {
      vp.addEventListener('click', function () { vp.classList.toggle('is-paused'); });
    });
  }

  function top() {
    document.querySelectorAll('[data-mp18-top]').forEach(function (b) {
      b.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: calm ? 'auto' : 'smooth' });
        var m = document.querySelector('main') || document.body;
        m.setAttribute('tabindex', '-1');
        m.focus({ preventScroll: true });
      });
    });
  }

  function init() { shop(); band(); top(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
